import { useMemo } from 'react';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import { Provider } from '@vgtv/api-client';

import { getAssetStructuredData } from '../../shared/helpers/getStructuredData';
import { config } from '../../config';
import { ABCategory, VGTVCategory } from '../../types';

import { useAssetCategoryMatch } from './useAssetCategoryMatch';

const useAssetStructuredData = (asset?: SvpAssetAdditional) => {
  const { isMatched, isFetching } = useAssetCategoryMatch(
    config.provider === Provider.VGTV ? VGTVCategory.NEWS : ABCategory.NEWS,
    // disabled for brandstudio
    asset?.provider === 'brandstudio' ? undefined : asset
  );

  return useMemo(() => {
    return asset && !isFetching
      ? getAssetStructuredData(asset!, isMatched)
      : undefined;
  }, [isFetching, isMatched, asset]);
};

export { useAssetStructuredData };
